import Spin from "antd/es/spin";
import "antd/es/spin/style";
import { Navigate, Outlet } from "react-router";

import useGetMaintenance from "./hooks/useGetMaintenance";
import inMemoryJwt from "./inMemoryJwt";
import { useBusinessIdGlobal } from "./hooks/useBusinessId";

const AppMaintenanceHandler = () => {
  const { businessId: CurrentbusinessId } = useBusinessIdGlobal();
  const { maintenanceData, isLoading } = useGetMaintenance(CurrentbusinessId);

  if (isLoading) {
    return (
      <div className="spin">
        <Spin />
      </div>
    );
  }

  if (maintenanceData?.is_offline) {
    inMemoryJwt.eraseToken();
    return <Navigate to="/under-maintenance" replace />;
  }

  return <Outlet />;
};

export default AppMaintenanceHandler;
